import styled from 'styled-components';

export const LazyFigure = styled.figure`
    margin: 2rem 0;
    padding: 0;
`;

export const LazyImageWrapper = styled.div<{ paddingBottom?: string }>`
    position: relative;
    padding-bottom: ${({ paddingBottom }) => paddingBottom || '100%'};
`;

export const LazyImageElement = styled.img`
    display: block;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
`;

export const LazyFigcaption = styled.figcaption`
    margin: 0.5rem 0 0;
`;
